import { Stack } from '@mui/material';
import { useLocation } from 'react-router-dom';

import { useGetIsUserPermittedTo } from '@occc/utils-access-control';

import { NavigationItem } from './types';
import { SidebarTopNavigationItem } from './SidebarTopNavigationItem';
import { getIsActive } from './utils';

type TopNavProps = {
  items: NavigationItem[];
};

export const TopNav = ({ items }: TopNavProps) => {
  const { pathname } = useLocation();
  const filter = useGetIsUserPermittedTo();

  return (
    <Stack>
      {items
        .filter((link) => filter(link.accessControlKey))
        .map((link) => (
          <SidebarTopNavigationItem
            key={link.title}
            isActive={getIsActive(link, pathname)}
            title={link.title}
            Icon={link.Icon}
            linkTo={link.location}
          />
        ))}
    </Stack>
  );
};
